<template>
  <div class="notification">
    <i :class="iconClass" />
    {{ message }}
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: ''
      },
      iconClass: {
        type: String,
        default: ''
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  .notification {
    background-color: $success;
    padding: 10px 16px;
    text-align: initial;
    font-weight: bold;
    font-size: 12px;
    display: flex;
    color: white;
    margin: 16px;

    i {
      line-height: 16px;
      font-size: 15px;
      margin-right: 16px;
      font-weight: bold;
    }
  }

</style>
